<template>
  <div v-loading="loading">
    <el-table :data="rows" :max-height="tableHeight" class="no-hover" stripe empty-text="暂无运营层数据，请先选择路线并完成 EV 推导">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.bins || []" size="mini" class="no-hover bin-table" :row-class-name="binRowClass">
            <el-table-column label="分箱" prop="binIndex" width="50"></el-table-column>
            <el-table-column label="X_μ区间" width="100">
              <template slot-scope="scope">
                [{{ raw(scope.row.intervalMin) }}, {{ raw(scope.row.intervalMax) }}]
              </template>
            </el-table-column>
            <el-table-column label="μ" width="80">
              <template slot-scope="scope">
                {{ formatNum(scope.row.mu) }}
              </template>
            </el-table-column>
            <el-table-column label="选中" width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.selected" class="selected-tag">是</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="binPoints" prop="binPoints" width="80">
              <template slot-scope="scope">
                {{ raw(scope.row.binPoints) }}
              </template>
            </el-table-column>
            <el-table-column label="evCoeff" prop="evCoeff" width="80">
              <template slot-scope="scope">
                {{ formatNum(scope.row.evCoeff) }}
              </template>
            </el-table-column>
            <el-table-column label="evContrib" prop="evContrib" width="90">
              <template slot-scope="scope">
                {{ formatNum(scope.row.evContrib) }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column label="时段" prop="slotRange" width="140"></el-table-column>

      <el-table-column label="S_op(现存量)" prop="supplyOp" width="100">
        <template slot="header">
          <el-tooltip content="按当前路线：可服务该路线的车辆现存量（非全区域所有车）" placement="top">
            <span>S_op(现存量)</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="Σz累计(prev)" prop="stopWorkCumPrev" width="110"></el-table-column>
      <el-table-column label="S_eff(有效)" prop="supplyOpEffective" width="100"></el-table-column>
      <el-table-column label="D(需求)" prop="demandCars" width="100">
        <template slot="header">
          <el-tooltip content="当前路线在本时段的订单需求车数" placement="top">
            <span>D(需求)</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- <el-table-column label="S_op(前缀和)" prop="supplyOpCumulative" width="100">
        <template slot="header">
          <el-tooltip content="Σ各slot S_op，仅诊断；非车数累计" placement="top">
            <span>S_op(前缀和)</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="X_op(S−D)" prop="surplusOp" width="100">
        <template slot-scope="scope">
          <span :class="{ shortage: scope.row.surplusOp != null && scope.row.surplusOp < 0 }">
            {{ raw(scope.row.surplusOp) }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column label="I*(库存目标)" prop="inventoryTarget" width="100">
        <template slot="header">
          <el-tooltip content="前向需求库存目标，仅用于调位 emptyTrip cap" placement="top">
            <span>I*(库存目标)</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="X_μ(S_eff−D)" prop="surplusOpMu" width="110">
        <template slot="header">
          <el-tooltip content="求解器 μ 分箱选档：X_μ = S_eff − D" placement="top">
            <span>X_μ(S_eff−D)</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span :class="{ shortage: scope.row.surplusOpMu != null && scope.row.surplusOpMu < 0 }">
            {{ raw(scope.row.surplusOpMu) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="P(收班总积分)" prop="scoreTotal" width="120">
        <template slot-scope="scope">
          {{ raw(scope.row.scoreTotal) }}
        </template>
      </el-table-column>
      <el-table-column label="Σz(收工车数)" prop="stopWorkCount" width="120">
        <template slot="header">
          <el-tooltip content="路线口径 Σz；若与全局不同会显示全局值" placement="top">
            <span>Σz(收工车数)</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span :class="{ 'stop-work-hit': displayStopZ(scope.row) > 0 }">
            {{ formatStopZ(scope.row) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="P_rem(节点)" width="100">
        <template slot-scope="scope">
          {{ formatPEffList(scope.row.nodeRemainingPoints) }}
        </template>
      </el-table-column>
      <el-table-column label="P_eff(单车)" width="100">
        <template slot-scope="scope">
          {{ formatPEffList(scope.row.precomputedPEff) }}
        </template>
      </el-table-column>
      <el-table-column label="μ分箱" width="70">
        <template slot-scope="scope">
          {{ scope.row.activeBinIndex != null && scope.row.activeBinIndex >= 0 ? scope.row.activeBinIndex : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="收工EV" prop="evObjective" width="90">
        <template slot-scope="scope">
          {{ formatNum(scope.row.evObjective) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
/** 运营层诊断面板：仅展示 API 原样返回的求解器快照，不做二次计算或默认值填充。 */
export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 480
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    raw(val) {
      return val === null || val === undefined ? "-" : val;
    },
    formatNum(val) {
      if (val === null || val === undefined) {
        return "-";
      }
      return this.$options.filters.numFormat(val, 2);
    },
    binRowClass({ row }) {
      return row.selected ? "bin-selected-row" : "";
    },
    formatPEffList(list) {
      if (!list || !list.length) {
        return "-";
      }
      const uniq = [...new Set(list)].sort((a, b) => a - b);
      return uniq.join(", ");
    },
    displayStopZ(row) {
      const pathZ = row.stopWorkCount == null ? 0 : row.stopWorkCount;
      const globalZ = row.globalStopWorkCount == null ? pathZ : row.globalStopWorkCount;
      return Math.max(pathZ, globalZ);
    },
    formatStopZ(row) {
      const pathZ = row.stopWorkCount;
      const globalZ = row.globalStopWorkCount;
      if (pathZ == null && globalZ == null) {
        return "-";
      }
      if (globalZ != null && pathZ != null && globalZ !== pathZ) {
        return `${pathZ} (全局${globalZ})`;
      }
      return this.raw(pathZ != null ? pathZ : globalZ);
    }
  }
};
</script>

<style lang="less" scoped>
.shortage {
  color: #f56c6c;
  font-weight: 600;
}

.selected-tag {
  color: #409eff;
  font-weight: 600;
}

.stop-work-hit {
  color: #e6a23c;
  font-weight: 600;
}

::v-deep .bin-selected-row {
  background-color: #ecf5ff !important;
}
</style>
